/**
 * Created by 张培博 on 2016/10/15.
 * 公用的一些操作
 */
import { message, Modal, notification as notice } from "antd";
import * as React from "react";
import ContextMgr from "./ContextMgr";
import EventMgr from "./EventMgr";
import ModalMgr from "./ModalMgr";
function noop() { }
class YxcCommon {
    constructor() {
        // 服务
        this.Service = {};
        // 类型 ..
        this.Types = {};
        /**
         * 事件管理
         */
        this.EventMgr = EventMgr;
        /**
         * 上下文管理
         */
        this.ContextMgr = ContextMgr;
        this.Log = {
            showError(message) {
                if (process.env.NODE_ENV === "loc" || process.env.NODE_ENV === "dev") {
                    notice.error({ description: message, message: "发生错误" });
                }
                else {
                    console.error(message);
                }
            },
            showWarn(message) {
                if (process.env.NODE_ENV === "loc" || process.env.NODE_ENV === "dev") {
                    notice.warn({ message: message });
                }
                else {
                    console.warn(message);
                }
            }
        };
        //  /**
        //  * 加载状态
        //  */
        // Spin:ISpin
        this.Event = {
            /**
             * 事件函数节流
             * @param InsComponent：ReactComponent
             * @param intervalTime: Number(毫秒)
             * @returns {{componentWillMount?(): void, componentDidMount?(): void, componentWillReceiveProps?(nextProps: Readonly<P>, nextContext: any): void, shouldComponentUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean, componentWillUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): void, componentDidUpdate?(prevProps: Readonly<P>, prevState: Readonly<S>, prevContext: any): void, componentWillUnmount?(): void, new(props?: P, context?: any): LocalSpin, prototype: LocalSpin}}
             */
            interval(InsComponent, intervalTime = 1000) {
                return class LocalSpin extends React.Component {
                    constructor() {
                        super(...arguments);
                        // 对要节流的事件作节流处理
                        this.handleProcess = eventType => {
                            // 拿到事件名称
                            let This = this;
                            return function () {
                                const event = This.props[eventType];
                                if (!event)
                                    return;
                                if (This.lock) {
                                    DCI.Notice.showInfo("您操作的频次太快了");
                                    return;
                                }
                                event();
                                This.lock = true;
                                // 设置定时器
                                setTimeout(() => {
                                    This.lock = false;
                                }, intervalTime);
                            };
                        };
                        // 过滤出所有要节流的事件
                        this.filterEvent = eventType => {
                            let eventMap = {};
                            if (typeof eventType === "string") {
                                eventMap[eventType] = this.handleProcess(eventType); // ???, eventMap);
                            }
                            else if (Array.isArray(eventType)) {
                                eventType.forEach(event => this.handleProcess(event)); // ???, eventMap));
                            }
                            else {
                                console.warn("eventType目前只支持String与String[]，检查你的 YXC.Event.interval()调用情况");
                            }
                            return eventMap;
                        };
                    }
                    render() {
                        const { onClick, intervalType = "onClick", children, ...restProps } = this.props;
                        const eventMap = this.filterEvent(intervalType);
                        return null;
                        //  return React.cloneElement(InsComponent, {...eventMap, ...restProps}, [...children])
                    }
                };
            }
        };
        /**
         *  通用消息
         */
        this.Msg = {
            /**
             * 错误消息
             * @param msg
             */
            showError(msg) {
                message.error({
                    message: msg,
                    type: "error",
                    showCloseButton: true
                });
            },
            /**
             * 提示信息
             * @param msg
             */
            showInfo(msg) {
                message.info({
                    message: msg,
                    type: "info",
                    showCloseButton: true
                });
            },
            /**
             * 警告信息¶¶
             * @param msg
             */
            showWarn(msg) {
                message.warn({
                    message: msg,
                    type: "warn",
                    showCloseButton: true
                });
            },
            /**
             * 显示成功信息
             * @param msg
             */
            showSuccess(msg) {
                message.success({
                    message: msg,
                    type: "success",
                    showCloseButton: true
                });
            },
            /**
             * 要求用户确认
             * @param content: string
             * @param onOk: function
             * @param onCancel: function
             */
            showConfirm(content, onOk, onCancel) {
                Modal.confirm({
                    title: "请确认以下操作",
                    okText: "确定",
                    cancelText: "取消",
                    content,
                    onOk,
                    onCancel
                });
            },
            /**
             * 要求输入
             * @param title: string
             * @param defaultValue?: string
             * @param onOk: function
             * @param onCancel: function
             */
            showPrompt(title, onOk, onCancel, defaultValue) {
                let newDefaultValue = defaultValue || "";
                let result = prompt(title, newDefaultValue);
                !!result && onOk(result);
                !result && !!onCancel && onCancel();
            }
        };
        /*
         * 系统消息
         */
        this.Notice = {
            showSuccess(content, onClose) {
                notice.success({
                    message: content.message || content,
                    description: content.description,
                    onClose: content.onClose ? content.onClose : onClose || noop
                });
            },
            showError(content, onClose) {
                notice.error({
                    message: content.message || content,
                    description: content.description,
                    onClose: content.onClose ? content.onClose : onClose || noop
                });
            },
            showWarn(content, onClose) {
                notice.warn({
                    message: content.message || content,
                    description: content.description,
                    onClose: content.onClose ? content.onClose : onClose || noop
                });
            },
            showInfo(content, onClose) {
                notice.info({
                    message: content.message || content,
                    description: content.description,
                    onClose: content.onClose ? content.onClose : onClose || noop
                });
            }
        };
        /**
         * 模态框
         */
        this.Modal = ModalMgr;
    }
}
window.YXC = new YxcCommon();
export default window.YXC;



// WEBPACK FOOTER //
// ./src/utils/base.jsx